import getValue from 'get-value'

/**
 * Sort data objects by one or more fields.
 * @param data
 * @param field1
 * @param field2
 * @param field2
 * @returns
 */
export function sorter<T>(data: T[], field1: string, field2: string | undefined = undefined, field3: string | undefined = undefined): T[] {
  return data.sort((_a, _b) => {
    const a = _a as unknown as Record<string, string | number>
    const b = _b as unknown as Record<string, string | number>
    if (getValue(a, field1) < getValue(b, field1)) {
      return -1
    }
    if (getValue(a, field1) > getValue(b, field1)) {
      return 1
    }
    if (field2 !== undefined) {
      if (getValue(a, field2) < getValue(b, field2)) {
        return -1
      }
      if (getValue(a, field2) > getValue(b, field2)) {
        return 1
      }
      if (field3 !== undefined) {
        if (getValue(a, field3) < getValue(b, field3)) {
          return -1
        }
        if (getValue(a, field3) > getValue(b, field3)) {
          return 1
        }
      }
    }
    return 0
  })
}

/**
 * Sort data objects by one or more fields, ignore case.
 * @param data
 * @param field1
 * @param field2
 * @param field2
 * @returns
 */
export function usorter<T>(data: T[], field1: string, field2: string | undefined = undefined, field3: string | undefined = undefined): T[] {
  return data.sort((_a, _b) => {
    const a = _a as unknown as Record<string, string | number>
    const b = _b as unknown as Record<string, string | number>
    if (`${getValue(a, field1)}`.toLowerCase() < `${getValue(b, field1)}`.toLowerCase()) {
      return -1
    }
    if (`${getValue(a, field1)}`.toLowerCase() > `${getValue(b, field1)}`.toLowerCase()) {
      return 1
    }
    if (field2 !== undefined) {
      if (`${getValue(a, field2)}`.toLowerCase() < `${getValue(b, field2)}`.toLowerCase()) {
        return -1
      }
      if (`${getValue(a, field2)}`.toLowerCase() > `${getValue(b, field2)}`.toLowerCase()) {
        return 1
      }
      if (field3 !== undefined) {
        if (`${getValue(a, field3)}`.toLowerCase() < `${getValue(b, field3)}`.toLowerCase()) {
          return -1
        }
        if (`${getValue(a, field3)}`.toLowerCase() > `${getValue(b, field3)}`.toLowerCase()) {
          return 1
        }
      }
    }
    return 0
  })
}
